import React, { Component } from 'react';
import autoBind from 'react-autobind/src/autoBind';
import { connect } from 'react-redux';
import { Entities, fetchById, patch, save, TOMCAT_URL } from 'src/common';
import ZoneCalculationForm from 'src/components/administration/zone-calculation/components/zone-calculation-form';
import { asyncCheckDuplicate } from 'src/components/misc/redux-form-helpers';

class ZoneCalculationAdministrationModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = {};
    }

    callSubmit() {
        return this.childForm.submit();
    }

    render() {
        const { geofenceAreas, geoZoneCalculation } = this.props;
        let initialValues = {
            ...geoZoneCalculation,
        };

        return (
            <ZoneCalculationForm
                ref={ref => (this.childForm = ref)}
                isCreate={false}
                geofenceAreas={geofenceAreas}
                onSubmit={this.handleSubmit}
                initialValues={initialValues}
                t={this.props.t}
            />
        );
    }

    didFormChange() {
        return !this.childForm.pristine;
    }

    handleSubmit(data) {
        const { patch, t, busCompany, selectedCountryCalc } = this.props;
        const request = { ...data };
        request.countryCalculation = `${TOMCAT_URL}api/${Entities.COUNTRY_CALCULATION.repository}/${selectedCountryCalc.id}`;
        request.zoneA = `${TOMCAT_URL}api/${Entities.GEOFENCE_AREA.repository}/${data.zoneA.id}`;
        request.company = `${TOMCAT_URL}api/${Entities.BUS_COMPANY.repository}/${busCompany.entity.id}`;

        if (request.zoneB !== null)
            request.zoneB = `${TOMCAT_URL}api/${Entities.GEOFENCE_AREA.repository}/${data.zoneB.id}`;

        patch(request, Entities.ZONE_CALCULATION).then(response => {
            this.props.addNotification(
                t('zone_calculation.response.success.title_edited'),
                t('zone_calculation.response.success.content_edited'),
                'success',
                'tr',
            );
        });

        this.props.handleClose();
    }
}

const mapStateToProps = state => {
    return {
        selectedCompany: state.selectedCompany,
    };
};

export default connect(
    mapStateToProps,
    {
        patch,
        save,
        fetchById,
        asyncCheckDuplicate,
    },
    null,
    { withRef: true },
)(ZoneCalculationAdministrationModal);
